<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ title || "input-locale" | translate }}</mat-label
      ><input
        type="text"
        matInput
        [matAutocomplete]="autoComplete"
        [required]="required"
        formControlName="name"
      />
      <mat-autocomplete autoActiveFirstOption #autoComplete="matAutocomplete">
        <mat-option
          *ngFor="let country of countries"
          (onSelectionChange)="handleCountryChange($event, country)"
          [value]="country.name.toUpperCase()"
          class="autocomplete"
        >
          {{ country.name | uppercase }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        translate
        *ngIf="this.searchForm.controls.name.touched && !this.searchForm.valid"
        >{{ requiredText || "required-locale" | translate }}</mat-error
      >
    </mat-form-field>
  </div>
</form>
